import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import {
    Modal, Grid, TextField, Divider, CircularProgress, Link, Paper, Button
} from '@mui/material';

import { liveTrackinglayoutSelector } from '../../features/layout/layoutSlice';
import {
    searchUsername, searchUserbyAsset, getUserAccess,
    clearState, setNeedFirstLoad,
    userSelector,
} from '../../features/user/UserSlice';
import {
    firstLoad,
    assetSocketConnect, assetSocketDisconnect,
} from '../../features/assets/assetsSlice';
import { defaultEventsLoad, setViewType } from '../../features/events/eventsSlice';
import { getPlaces } from '../../features/places/placesApi';

import GoogleCreditLimit from './GoogleCreditLimit';
import SearchIcon from '@mui/icons-material/Search';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';

const AdminMainModal = ({ adminOpen, handleAdminClose }) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const dimention = useSelector(liveTrackinglayoutSelector);
    const { sockHost } = useSelector(userSelector);

    const searchingUsers = useSelector(state => state.user.searchingUsers);
    const searchedUsers = useSelector(state => state.user.searchedUsers);
    const accessSuccess = useSelector(state => state.user.isSuccess);
    const token = useSelector(state => state.user.token);

    const [search, setSearch] = useState('');
    const [searchtype, setSearchtype] = useState('username');

    const onSearch = () => {
        if (searchtype === 'username') {
            onUserSearch();
        } else {
            onAssetSearch();
        }
    }

    const onUserSearch = () => {
        dispatch(searchUsername({ searchUser: search }));
        setSearchtype('username');
    }

    const onAssetSearch = () => {
        dispatch(searchUserbyAsset({ searchAsset: search }));
        setSearchtype('asset');
    }

    const [googleKeyOpen, setGoogleKeyOpen] = useState(false);
    const [mapUser, setMapUser] = useState(null);
    const handleGoogleKeyClose = () => {
        setGoogleKeyOpen(false);
        setMapUser(null);
    }
    const handleGoogleKeyOpen = (user) => {
        setGoogleKeyOpen(true);
        setMapUser(user);
    }


    useEffect(() => {
        if (accessSuccess) {
            console.log("Admin auth Success");
            handleAdminClose();
            dispatch(assetSocketDisconnect(sockHost));
            dispatch(clearState());
            dispatch(setNeedFirstLoad(true));
            history.push('/secured/livetracking');
            //dispatch(unload());
            dispatch(firstLoad());
            console.log("Admin auth Success", sockHost, token);
            dispatch(assetSocketConnect({ host: sockHost, token: token }));
            dispatch(getPlaces());
            dispatch(setViewType('default'));
            dispatch(defaultEventsLoad({ hours: 2 }));
            dispatch(setNeedFirstLoad(false));
        }
    }, [accessSuccess, dispatch, history, handleAdminClose, sockHost, token]);
    return (
        <Modal
            open={adminOpen}
            onClose={handleAdminClose}
        >
            <div style={{ ...dimention.adminModal, overflow: 'auto' }}>
                <Card>
                    <CardHeader
                        title="Search Users"
                        subheader="username or vehicle number"
                    />
                    <CardContent>

                        <Grid
                            container
                            spacing={2} direction="row"
                            justifyContent="space-between"
                            alignItems="center"
                        >
                            <Grid item sm={4}>
                                <FormControl component="fieldset">
                                    <FormLabel component="legend">Search Type</FormLabel>
                                    <RadioGroup
                                        row
                                        value={searchtype}
                                        onChange={(e) => setSearchtype(e.target.value)}
                                    >
                                        <FormControlLabel value="username" control={<Radio />} label="User" />
                                        <FormControlLabel value="asset" control={<Radio />} label="Vehicle Number" />
                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                            <Grid item sm={6} style={{ display: "flex" }}>
                                <TextField
                                    variant="standard"
                                    id="search"
                                    label={`Search ${searchtype === 'username' ? 'User' : 'Vehicle'}`}
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)}
                                    onKeyPress={(ev) => ev.key === 'Enter' ? onSearch() : null}
                                />
                                <Button
                                    onClick={onSearch}
                                    variant="contained"
                                    startIcon={<SearchIcon />}
                                    size="large"
                                >
                                    {`Search ${searchtype === 'username' ? 'User' : 'Vehicle'}`}
                                </Button>
                            </Grid>
                            <Grid item sm={2}>

                            </Grid>
                        </Grid>

                        <div style={{ height: '15px' }}>
                            <Divider />
                        </div>
                        {
                            searchingUsers && <CircularProgress />
                        }
                        {
                            searchedUsers &&
                            <TableContainer component={Paper}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Userid</TableCell>
                                            <TableCell>Username</TableCell>
                                            {searchtype === 'asset' && <TableCell align="right">Vehicle</TableCell>}
                                            <TableCell>Assets</TableCell>
                                            <TableCell align="right"></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {searchedUsers.map(s => (
                                            <TableRow key={s.userid}>
                                                <TableCell>{s.userid}</TableCell>
                                                <TableCell component="th" scope="row">
                                                    {
                                                        s.privileges !== 'subuser' ?
                                                            <Link href="#" onClick={() => dispatch(getUserAccess({ requestedUser: s.username }))}>
                                                                <span style={{
                                                                    color: s.active === "true" ? "DodgerBlue" : "FireBrick",
                                                                }}><b>{s.username}</b></span>
                                                            </Link>
                                                            :
                                                            s.username
                                                    }

                                                </TableCell>
                                                {searchtype === 'asset' && <TableCell align="right">{s.assetName}</TableCell>}
                                                <TableCell><b>{s.assets}</b></TableCell>
                                                <TableCell align="right">
                                                    {
                                                        s.active === "true" &&
                                                        <Link href="#" onClick={() => handleGoogleKeyOpen(s)}>
                                                            <span style={{ color: 'FireBrick' }}>
                                                                Google Map Credits
                                                            </span>
                                                        </Link>
                                                    }

                                                </TableCell>
                                            </TableRow>

                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>

                        }
                    </CardContent>



                </Card>
                <GoogleCreditLimit
                    googleKeyOpen={googleKeyOpen}
                    handleGoogleKeyClose={handleGoogleKeyClose}
                    mapUser={mapUser}
                />
            </div>
        </Modal>
    );
}

export default AdminMainModal;

